import React, { useEffect, useRef } from "react";

const ViewScoresModal = ({
  isOpen,
  closeModal,
  challengeName,
  scores,
  topScoreIds,
}) => {
  const modalRef = useRef(null);

  useEffect(() => {
    if (isOpen && modalRef.current) {
      modalRef.current.scrollTop = 0;
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const formatDate = (dateStr) => {
    const [month, day, year] = dateStr.split("/");
    return `${parseInt(month)}/${parseInt(day)}/${year.slice(-2)}`;
  };

  const transformScore = (score) => ({
    netScore: score.net_score,
    netRelation: score.net_to_par,
    adjGrossScore: score.adjusted_gross_score,
    grossRelation: score.gross_to_par,
    courseHandicap: score.course_handicap,
    tees: score.tee_name,
    courseRating: score.cr_slope,
    datePlayed: formatDate(score.played_at),
    topScore: topScoreIds.includes(score.score_id),
  });

  const finalScores = scores
    ? scores
        .sort((a, b) => new Date(b.score_id) - new Date(a.score_id))
        .map(transformScore)
    : [];

  return (
    <div className="modal-overlay">
      <div className="scores-modal-container" ref={modalRef}>
        <button
          className="close-modal"
          onClick={closeModal}
          aria-label="Close"
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "none",
            border: "none",
            fontSize: "24px",
            cursor: "pointer",
            zIndex: 1,
          }}
        >
          &times;
        </button>
        <h2 className="modal-title">{challengeName}</h2>
        <h3 className="modal-subtitle">Score Details</h3>

        <div className="score-table">
          <div className="score-row header">
            <div className="score-cell w5"></div>
            <div className="score-cell left net-score">NET SCORE</div>
            <div className="score-cell gross-score">ADJ. GROSS SCORE</div>
            <div className="score-cell handicap">COURSE HANDICAP</div>
            <div className="score-cell tees">TEES</div>
            <div className="score-cell date">DATE PLAYED</div>
          </div>
          {finalScores.map((score, index) => (
            <div className="score-row body" key={index}>
              <div className="score-cell w5">
                <div
                  className={"blue-dot " + (score.topScore ? "" : "invisible")}
                ></div>
              </div>
              <div className="score-cell net left net-score">
                {score.netScore} <span>({score.netRelation})</span>
              </div>
              <div className="score-cell gross-score">
                {score.adjGrossScore}{" "}
                <span className="score-relation">({score.grossRelation})</span>
              </div>
              <div className="score-cell handicap">{score.courseHandicap}</div>
              <div className="score-cell tees">
                {score.tees}
                <span className="course-rating">{score.courseRating}</span>
              </div>
              <div className="score-cell date">{score.datePlayed}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ViewScoresModal;
